import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import * as actionsPolicy  from '../../../../../app/actions/policy';
import {findLastUnpaidCashflow, isNoCyrilicFound, setInstallmentText} from '../../../../../app/common/services/vehicle.service';
import { NuInsInputTextLabel, NuInsInputNumLabel, NuInsSelectGroupLabel } from '../../elements/inputFieldsLabel';
import {BackIcon} from '../../svg/iconsSvg';
import countryCodes from '../common/countryCodes.json';
import SelectDeliveryAddress from '../elements/SelectDeliveryAddress';


const countryCodesOptions = countryCodes.map((doc, i) => ({label: doc["COUNTRY_NAME"], value: doc["PHONE_CODE"], key: i+1, code: doc["COUNTRY_CODE"] , order: doc["VIEW_ORDER"]}));

const PayInstDelivery = ({onForward, onBack, policy, updateShipmentDetails}) => {

    const userDetails     = useSelector(state => state.userDetails);

    const shipmentDetails = useSelector(state => state.shipmentDetails);
    const {receiverName , deliveryAddress} = shipmentDetails || {};

    const [deliveryPhone, setDeliveryPhone] = useState({countryCode: '359', phoneNo: null});
    const [deliveryAddressModal, setDeliveryAddressModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const [checkFields, setCheckFields] = useState({});

    const unpaidCashFlow = findLastUnpaidCashflow(policy?.cashflows);

    const plate = policy?.registrationProps?.plate?.value;

    const inputFields = ['receiverName', 'phoneNo'];
    const errorMsg    = "Полето е задължително";

    useEffect(() => {
        if(userDetails?.firstNameCyrillic && userDetails?.lastNameCyrillic) {
            updateShipmentDetails({receiverName: `${userDetails.firstNameCyrillic} ${userDetails.lastNameCyrillic}`});
        }
    },[userDetails, updateShipmentDetails])

    useEffect(() => {

        if(userDetails.phone && !shipmentDetails?.receiverPhone) {
            const phone = userDetails.phone;
            updateShipmentDetails({receiverPhone: `${phone.countryCode}${phone.phoneNo}`});
            setDeliveryPhone({countryCode: phone.countryCode, phoneNo: phone.phoneNo});
        }

       // console.log(shipmentDetails?.deliveryAddress)

    }, [userDetails, shipmentDetails, updateShipmentDetails]);

    const goBack = () => onBack(2);

    const goForward = () => onForward(4, null, null, unpaidCashFlow.cashflowId);

    const onChangeHandler = (field, data) => {
        switch(field) {
            case 'countryCode':
                data = data.replace(/[^0-9]/,"");
                updateShipmentDetails({'receiverPhone': `${data}${deliveryPhone?.phoneNo}`});
                setDeliveryPhone({countryCode: data, phoneNo: deliveryPhone?.phoneNo});
                return
            case 'phoneNo':
                updateShipmentDetails({'receiverPhone': `${deliveryPhone?.countryCode}${data}`});
                setDeliveryPhone({countryCode: deliveryPhone?.countryCode, phoneNo: data});
                return
           
            default:
                updateShipmentDetails({[field]: data });
                return;
        } 
    }

    const phoneValidation = () => {
        if(deliveryPhone.countryCode  && deliveryPhone.phoneNo && deliveryPhone.phoneNo.length === 9  ) return false;

        return true;
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = shipmentDetails[field] ? isNoCyrilicFound(shipmentDetails[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !shipmentDetails[field]);
            case 'phoneNo':
                return (checkFields[field] || allFields) && (!deliveryPhone[field] || phoneValidation());
            default:
                return (checkFields[field] || allFields) && !shipmentDetails[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${shipmentDetails[field] ? 'на кирилица' : ''}`;
            case 'phoneNo':
                if(!deliveryPhone[field]) return errorMsg;
                if(deliveryPhone[field] && phoneValidation()) return "Невалиден номер";
                break
            default:
                return errorMsg;
        }
    }

    const closeModal = () => {
        setDeliveryAddressModal(false);
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field === 'phoneNo') {
                if(checkForError(field, 'phoneNo', true)) return false;
            }
        }

        return true;
    }

    const submitHandler = async () => {
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(valdateAllFields() && deliveryAddress) {
            goForward();
        } else if(valdateAllFields() && !deliveryAddress) {
            setDeliveryAddressModal(true)
        }
    }

    return (
        <div className="steps_container" >
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(unpaidCashFlow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>{policy?.policyId}</p>
                    <p style={{fontWeight: '700'}}>{plate}</p>
                    
                </div>
                <div  className="right" >
                    <p style={{marginBottom: '8px'}}>Сума за плащане</p>
                    <p style={{fontWeight: '700', fontSize: '15px'}}>{unpaidCashFlow?.dueAmountEUR} € / {unpaidCashFlow?.dueAmount} лв.</p>
                </div>
            </div>

            <h6 className='color-heaven-1' style={{paddingLeft:"2rem", fontWeight: '500', margin: '20px 0'}}>Доставка</h6>
            
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('receiverName', data)} onBlur={()=>onBlurHandler('receiverName')} 
                placeholder={"Получател"} 
                value={receiverName} 
                error={checkForError('receiverName', 'cyrilic')} 
                errorMsg={generateErrorMsg('receiverName', 'cyrilic')}
                styles={{marginBottom: '20px'}}/>

            <div className="address-telephone-container" style={{marginBottom: '20px'}}>          
                <NuInsSelectGroupLabel onChange={(data)=>onChangeHandler('countryCode', data)}
                value={'+' + deliveryPhone.countryCode}
                placeholder={"Телефон"}
                options={countryCodesOptions} 
                ></NuInsSelectGroupLabel>
                <div style={{marginLeft:'4px'}}>
                    <NuInsInputNumLabel onChange={(data)=>onChangeHandler('phoneNo', data)} onBlur={()=>onBlurHandler('phoneNo')}
                                        validationType={"vin"} slice={9} 
                                        value={deliveryPhone.phoneNo}
                                        placeholder={" "}                                  
                                        error= {checkForError('phoneNo', 'phoneNo')}
                                        errorMsg={generateErrorMsg('phoneNo', 'phoneNo')}
                                        /> 
                </div>       
            </div>
      
            <SelectDeliveryAddress />
            <Divider />
            <button className="nuIns-btn nuIns-btn-main nuIns-btn-mx" type="submit" onClick={submitHandler}>Продължи</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

             {/* Modal for delivery address */}
             <Modal size="xs" show={deliveryAddressModal} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Избери адрес за доставка</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default connect(null, {...actionsPolicy})(PayInstDelivery);